<template>
  <RouterView />

  <Teleport to="body">
    <div class="toast-container">
      <TransitionGroup name="slide-fade">
        <ToastMessage
          v-for="toast in toastStore.toasts"
          :key="toast.id"
          :message="toast.message"
          :type="toast.type"
          @dismissed="toastStore.remove(toast.id)"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup>
import { useToastStore } from '@/store';

import { ToastMessage } from '@/components/toasts';

const toastStore = useToastStore();
</script>

<!--i think these styles have to be both in the transitiongroup file and scoped-->
<style scoped>
.fade.show {
  display: flex !important;
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: transform 0.5s ease-out, opacity 0.5s ease-out;
}

.slide-fade-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
